import Button from '@mui/material/Button';
import { FallbackProps } from 'components/core/AlluraErrorBoundary/AlluraErrorBoundary';
import { useRouter } from 'next/router';
import React, { useRef } from 'react';

const isDevelopment = process.env.NODE_ENV === 'development';

export const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const router = useRouter();

  // TODO - FIGOURE OUT WHY THIS IS HERE

  const prevPathname = useRef(router.route);

  React.useEffect(() => {
    if (router.route !== prevPathname.current) {
      resetErrorBoundary();
    }
    prevPathname.current = router.pathname;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div role="alert">
      <p>Whoops! An error occurred</p>
      {isDevelopment ? <pre style={{ color: 'red' }}>{error.message}</pre> : null}
      <Button onClick={() => window?.location.reload()}>Try again</Button>
    </div>
  );
};
